<template>
    <div>
        <Card :bordered="false" :dis-hover="true" style="width:99%;position:absolute;">
            <transition name="fade">
                <Row v-if="mainTable.sarchCardShow" :gutter="24">
                    <Col span="24">
                    <search-card :form="mainTable.searchForm" :table-load-event="getMainTableRecords"
                        :table-search="mainTable.tableSearch" />
                    </Col>
                </Row>
            </transition>
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">发货单列表</span>
                        <span style="margin-left:20px;">会员类别:</span>
                        <RadioGroup v-model="userType" style="margin-left:4px;" @on-change="onUserTypeChage">
                            <Radio label="F"> <span>外部会员</span></Radio>
                            <Radio label="E"> <span>内部会员</span></Radio>
                        </RadioGroup>
                        <Checkbox v-model="showYSColumns" style="margin-left: 20px;">显示用友状态</Checkbox>
                    </div>
                    <div class="right-bar">
                        <Button type="info" size="small" class="btns" shape="circle" icon="ios-search"
                            @click="onExport()">导出</Button>
                        <Button type="primary" size="small" class="btns" shape="circle" icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTableColumns" :data="mainTable.tableData" :extHeight="60"
                    :loading="mainTable.tableLoading" :table-search="mainTable.tableSearch"
                    :table-load-event="getMainTableRecords" />
                </Col>
            </Row>
        </Card>

        <RefundGoods ref="refundGoods" @close="onRefundGoodsClose" />

        <PreSaleDeliveryDetail ref="preSaleDeliveryDetailModal" />

        <payModalDetail ref="PayModal" />

        <Modal v-model="revokeModal.show" title="发货单撤销备注" class-name="vertical-center-modal" width="800">
            <Spin v-if="innerSpin" size="large" fix></Spin>
            <Form label-position="top" ref="revokeModal" :model="revokeModal" :rules="ruleValidate">
                <Row :gutter="16">
                    <Col span="24">
                    <FormItem label="撤销原因:" prop="revokeRemarks">
                        <Input type="textarea" v-model="revokeModal.revokeRemarks">
                        </Input>
                    </FormItem>
                    </Col>
                </Row>
            </Form>
            <div slot="footer">
                <Button type="error" @click="revokeSave">确定</Button>
                <Button type="error" @click="revokeCancal">关闭</Button>
            </div>
        </Modal>

        <InvoiceModal ref="invoiceModal" @submit="handleInvoiceSubmit" @cancel="handleInvoiceCancel"
            @invoice-submitted="handleInvoiceSubmitted" @invoice-submit-error="handleInvoiceSubmitError" />
    </div>
</template>

<script>

import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import search from '@/libs/search';
import { dateRender, dateTimeRender } from '@/libs/tableRowTimeRender';
import PreSaleDeliveryDetail from './preSale-delivery-detail';
import { getPreSaleDeliveryList, updatePreSaleDeliveryByUuid, SubmitPreSaleDelivery, DeletePreSaleDelivery, closePreSaleDeliveryByUuid, canclePreSaleDeliveryByUuid, cancelPreSaleDeliveryByUuidIn24, depositBillOrderReturnDepositFee } from '@/api/modules/preSale-management/preSale-delivery';
import RefundGoods from './refund-goods';
import { DOWNLOAD_SERVER } from '@/api/modules/files';
import payModalDetail from '../../sale-management/sale-help-put-cart/pay';
import { webGetAllRegion } from '@/api/modules/system-management/region-management';
import { ysTransferApplySync, ysTransferApplyDel } from '@/api/modules/system-management/ys-log-management';
import { getInvoiceInfo } from '@/api/modules/finance-management/invoice';
import InvoiceModal from '@/view/finance-management/invoice/invoice-modal.vue';
export default {
    name: 'PreSaleDeliveryList',
    components: {
        StandPaginationTable,
        SearchCard,
        PreSaleDeliveryDetail,
        RefundGoods,
        payModalDetail,
        InvoiceModal
    },
    data() {
        return {
            showYSColumns: false,
            userType: 'F',
            innerSpin: false,
            invoiceModalVisible: false,
            ysStatusConfig: {
                StoreinUnauditType: 1,
                StoreinDelType: 2,
                StoreoutUnauditType: 11,
                StoreoutDelType: 12,
                TransferapplyUnauditType: 21,
                TransferapplyDelType: 22,
                TransferApply: 1,
                Storeout: 2,
                Storein: 3
            },
            // paySumbit:false,
            // paymentInformation: {
            // 	amount: 0,
            // 	userUuid: ''
            // },
            mainTable: {
                tableData: [],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                sarchCardShow: true,
                searchForm: [
                    { label: '发货单号', type: 'Input', value: '', name: 'preSaleDeliveryRecordCode', sql: 'like' },
                    { label: '定金单号', type: 'Input', value: '', name: 'preSaleDeliveryRecordRelateOrderRecordCode', sql: 'like' },
                    { label: '发货日期', type: 'Daterange', value: '', name: 'preSaleDeliveryRecordDeliveryDate', sql: 'dateBetween' },
                    { label: '制单时间', type: 'Daterange', value: '', name: 'preSaleDeliveryRecordCreateAt', sql: 'dateBetween' },
                    { label: '发货苗场', type: 'Input', value: '', name: 'seedFarmName', sql: 'like' },
                    { label: '会员信息', type: 'Input', value: '', name: 'concat(preSaleDeliveryRecords.userName, preSaleDeliveryRecords.userPersonName) ', sql: 'like' },
                    {
                        label: '发货单状态',
                        type: 'Select',
                        value: [],
                        name: 'preSaleDeliveryRecordStatus',
                        sql: 'in',
                        options: [{ key: '未提交', value: -1 }, { key: '未发货', value: 0 }, { key: '已发货', value: 1 }, { key: '关闭', value: 2 }, { key: '撤单', value: 3 }]
                    },
                    {
                        label: '转运站发货状态',
                        type: 'Select',
                        value: [],
                        name: 'stationDeliveryType',
                        sql: 'in',
                        options: [{ key: '未发货', value: '未发货' }, { key: '已发货', value: '已发货' }]
                    },
                    {
                        label: '客户收货状态',
                        type: 'Select',
                        value: [],
                        name: 'preSaleDeliveryRecordReceivingStatus',
                        sql: 'in',
                        options: [{ key: '未收货', value: 0 }, { key: '已收货', value: 1 }]
                    },
                    {
                        label: '省',
                        type: 'Select',
                        value: [],
                        name: 'depositBillRecordProvince',
                        sql: 'eq',
                        options: [],
                        change: (val) => {
                            this.onProvinceChange(val.value);
                        },
                        filterable: true
                    },
                    {
                        label: '市',
                        type: 'Select',
                        value: [],
                        name: 'depositBillRecordCity',
                        sql: 'eq',
                        options: [],
                        change: (val) => {
                            this.onCityChange(val.value);
                        },
                        filterable: true
                    },
                    {
                        label: '区/县',
                        type: 'Select',
                        value: [],
                        name: 'depositBillRecordDist',
                        sql: 'eq',
                        options: [],
                        filterable: true
                    },
                    {
                        label: '地址拆分',
                        type: 'Select',
                        value: [],
                        name: 'addressSplit',
                        sql: 'eq',
                        options: [{ key: '否', value: 0 }, { key: '是', value: 1 }]
                    },
                    { label: '小类', type: 'Input', value: '', name: 'subCategoryName', sql: 'like' },
                    { label: '品种', type: 'Input', value: '', name: 'productName', sql: 'like' },
                    {
                        label: '是否返定金',
                        type: 'Select',
                        value: [],
                        name: 'isReturnDepositFee',
                        sql: 'in',
                        options: [{ key: '否', value: 0 }, { key: '是', value: 1 }]
                    }
                ]
            },
            checkStatusOrder: 0,
            deliveryOrder: 0,
            receiveOrder: 0,
            revokeModal: {
                show: false,
                recordUuid: '',
                revokeRemarks: ''
            },
            ruleValidate: {
                revokeRemarks: [
                    { required: true, message: '请输入撤单备注!', trigger: 'blur' }
                ]
            },
            allRegions: [],
            provinceOptions: [],
            cityOptions: [],
            distOptions: []
        };
    },
    // props: {
    //     userType: { type: String, default: '' }
    // },
    mounted() {
        this.init();
    },
    computed: {
        mainTableColumns() {
            const baseColumns = [
                { title: '发货单号', key: 'preSaleDeliveryRecordCode', align: 'center' },
                { title: '关联定金单号', key: 'preSaleDeliveryRecordRelateOrderRecordCode', align: 'center' },
                { title: '会员号', key: 'userName', align: 'center', width: 55 },
                { title: '会员名', key: 'userPersonName', align: 'center', width: 60 },
                { title: '客戶经理', key: 'managerName', align: 'center', width: 60 },
                { title: '收款量', key: 'preSaleDeliveryRecordCollectionQuantity', align: 'center', width: 50 },
                { title: '实际发货量', key: 'receiveQuantity', align: 'center', width: 50 },
                { title: '本批发货量', key: 'preSaleDeliveryRecordTotalQuantity', align: 'center', width: 50 },
                { title: '已付定金', key: 'depositDue', align: 'center', width: 60 },
                { title: '销售金额', key: 'totalOrderCost', align: 'center', width: 60 },
                {
                    title: '定单合计', key: 'smallTotalOrderCost', align: 'center', width: 60,
                    render: (h, params) => {
                        return h('span', parseFloat(params.row.smallTotalOrderCost.toFixed(2)));
                    }
                },
                { title: '佣金比例(%)', key: 'salesAssociateCommissionPercent', align: 'center', width: 65 },
                { title: '发货苗场', key: 'seedFarmName', align: 'center' },
                {
                    title: '发货单状态', key: 'preSaleDeliveryRecordStatus', align: 'center', width: 60,
                    renderHeader: (h, { column, index }) => {
                        return h('div',
                            [
                                h('span', {}, column.title),
                                h('icon', {
                                    props: {
                                        type: this.checkStatusOrderIcon,
                                        size: 16
                                    },
                                    style: {
                                        marginLeft: '4px'
                                    },
                                    on: {
                                        click: () => {
                                            this.onCheckStatusOrderChange();
                                        }
                                    }
                                })
                            ]
                        );
                    },
                    render: (h, params) => {
                        return h('span', {}, this.getPreSaleDeliveryRecordStatus(params.row.preSaleDeliveryRecordStatus));
                    }
                },
                { title: '转运站', key: 'distributionStationName', align: 'center' },
                {
                    title: '转运站状态', key: 'stationDeliveryType', align: 'center', width: 60,
                    renderHeader: (h, { column, index }) => {
                        return h('div',
                            [
                                h('span', {}, column.title),
                                h('icon', {
                                    props: {
                                        type: this.deliveryOrderIcon,
                                        size: 16
                                    },
                                    style: {
                                        marginLeft: '4px'
                                    },
                                    on: {
                                        click: () => {
                                            this.onDeliveryChange();
                                        }
                                    }
                                })
                            ]
                        );
                    }
                },
                {
                    title: '客户收货状态', key: 'preSaleDeliveryRecordReceivingStatus', align: 'center',
                    renderHeader: (h, { column, index }) => {
                        return h('div',
                            [
                                h('span', {}, column.title),
                                h('icon', {
                                    props: {
                                        type: this.receiveOrderIcon,
                                        size: 16
                                    },
                                    style: {
                                        marginLeft: '4px'
                                    },
                                    on: {
                                        click: () => {
                                            this.onReceiveOrderChange();
                                        }
                                    }
                                })
                            ]
                        );
                    },
                    render: (h, params) => {
                        if (params.row.userCustomerManagerName == '总合计' || params.row.userCustomerManagerName == '本页合计') {
                            return h('span', '');
                        }
                        else {
                            return h('span', {}, params.row.preSaleDeliveryRecordReceivingStatus === 1 ? '已收货' : '未收货');
                        }
                    }
                },
                { title: '物流公司', key: 'preSaleDeliveryRecordLogisticsCompanyName', align: 'center' },
                { title: '发货日期', key: 'preSaleDeliveryRecordDeliveryDate', align: 'center', width: 70, render: (h, params) => dateRender(h, params.row.preSaleDeliveryRecordDeliveryDate) },
                { title: '制单时间', key: 'preSaleDeliveryRecordCreateAt', align: 'center', render: (h, params) => dateTimeRender(h, params.row.preSaleDeliveryRecordCreateAt) },
                { title: '客户备注', key: 'customerMsg', align: 'center' },
                { title: '定单备注', key: 'orderRemark', align: 'center' },
                {
                    title: '操作',
                    key: 'action',
                    align: 'center',
                    width: 85,
                    render: (h, params) => {
                        if (params.row.userCustomerManagerName == '总合计' || params.row.userCustomerManagerName == '本页合计') {
                            return h('span', '');
                        }
                        let targetTime = new Date(params.row.preSaleDeliveryRecordDeliveryDate);
                        let currentTime = new Date();
                        let diffHours = Math.abs(currentTime - targetTime) / (60 * 1000);
                        let diffDays = Math.floor(Math.abs(currentTime - targetTime) / (1000 * 60 * 60 * 24));
                        let twoMonthsLater = new Date(targetTime);
                        twoMonthsLater.setMonth(twoMonthsLater.getMonth() + 2);
                        let isWithinTwoMonths = currentTime <= twoMonthsLater;
                        const hasInvoiceSerialNum = params.row.invoiceSerialNum && params.row.invoiceSerialNum.toString().trim() !== '';
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small',
                                    shape: 'circle'
                                },
                                on: {
                                    click: () => {
                                        this.$refs.preSaleDeliveryDetailModal.showModal(params.row.preSaleDeliveryRecordUuid);
                                    }
                                }
                            }, '查看'),
                            h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small',
                                    shape: 'circle'
                                },
                                style: {
                                    display: (this.$checkAccessArray(['B', 'C']) && params.row.preSaleDeliveryRecordStatus == -1) ? 'inline' : 'none'
                                },
                                on: {
                                    click: () => {
                                        this.sumbitOrder(params.row.preSaleDeliveryRecordUuid);
                                    }
                                }
                            }, '提交'),
                            h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small',
                                    shape: 'circle'
                                },
                                style: {
                                    display: (this.$checkAccessArray(['B', 'C']) && params.row.preSaleDeliveryRecordStatus == -1) ? 'inline' : 'none'
                                },
                                on: {
                                    click: () => {
                                        this.deleteOrder(params.row.preSaleDeliveryRecordUuid);
                                    }
                                }
                            }, '删除'),
                            h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small',
                                    shape: 'circle'
                                },
                                style: {
                                    display: (this.$checkAccessArray(['B', 'C', 'S']) && params.row.preSaleDeliveryRecordStatus == 0) ? 'inline' : 'none'
                                },
                                on: {
                                    click: () => {
                                        this.closeOrder(params.row.preSaleDeliveryRecordUuid);
                                    }
                                }
                            }, '关闭'),
                            h('Button', {
                                props: {
                                    type: 'success',
                                    size: 'small',
                                    shape: 'circle',
                                    disabled: (params.row.preSaleDeliveryRecordReceivingStatus === 1)
                                },
                                style: {
                                    display: (this.$checkAccessArray(['B', 'C', 'S']) && params.row.preSaleDeliveryRecordStatus == 0) ? 'inline' : 'none',
                                    marginTop: '5px',
                                    visibility: (params.row.preSaleDeliveryRecordStatus == 2 || params.row.preSaleDeliveryRecordStatus == 0 || params.row.preSaleDeliveryRecordStatus == 3) ? 'hidden' : 'visible'
                                },
                                on: {
                                    click: () => {
                                        this.receivingChange(params.row.preSaleDeliveryRecordUuid);
                                    }
                                }
                            }, '客户已收货'),
                            h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small',
                                    shape: 'circle'
                                },
                                style: {
                                    display: (this.$checkAccessArray(['B', 'C', 'S']) && params.row.preSaleDeliveryRecordStatus == 1 && params.row.preSaleDeliveryRecordReceivingStatus !== 1 && diffHours <= 1440 && diffHours > 0) ? 'inline' : 'none'
                                },
                                on: {
                                    click: () => {
                                        this.revokeDelivery(params.row.preSaleDeliveryRecordUuid);
                                    }
                                }
                            }, '撤单'),
                            h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small',
                                    shape: 'circle'
                                },
                                style: {
                                    display: (this.$checkAccessArray(['B', 'C']) && params.row.isReturnDepositFee == 0) ? 'inline' : 'none'
                                },
                                on: {
                                    click: () => {
                                        this.returnDepositFee(params.row.preSaleDeliveryRecordUuid);
                                    }
                                }
                            }, '返定金'),
                            h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small',
                                    shape: 'circle'
                                },
                                style: {
                                    display: (this.$checkAccessArray(['F', 'B', 'G']) && params.row.preSaleDeliveryRecordStatus == 1 && isWithinTwoMonths && !hasInvoiceSerialNum) ? 'inline' : 'none'
                                },
                                on: {
                                    click: () => {
                                        this.applyInvoice(params.row.preSaleDeliveryRecordUuid, params.row.smallTotalOrderCost, params.row.totalPackageFee, params.row.preSaleDeliveryRecordTotalLogisticsPrice, params.row.preSaleDeliveryRecordTotalCost);
                                    }
                                }
                            }, '开发票'),
                            h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small',
                                    shape: 'circle'
                                },
                                style: {
                                    display: hasInvoiceSerialNum ? 'inline' : 'none'
                                },
                                on: {
                                    click: () => {
                                        this.viewInvoice(params.row);
                                    }
                                }
                            }, '查看发票')
                        ]);
                    }
                }
            ];

            const ysColumns = [
                {
                    title: '用友调拨单',
                    key: 'ysTransferApplyInfo',
                    align: 'center',
                    render: (h, params) => {
                        return this.renderYSTransferApply(h, params.row);
                    }
                },
                {
                    title: '用友销售单',
                    key: 'ysVoucherOrderId',
                    align: 'center',
                    render: (h, params) => {
                        if (params.row.userCustomerManagerName === '总合计' || params.row.userCustomerManagerName === '本页合计') {
                            return h('span', '');
                        }

                        const isSynced = params.row.ysVoucherOrderId && params.row.ysVoucherOrderId.toString().trim() !== '';
                        return h('Tooltip', {
                            props: {
                                content: '发货后48小时同步',
                                placement: 'top',
                                transfer: true
                            }
                        }, [
                            h('span', {
                                style: {
                                    color: isSynced ? '#19be6b' : '#ed4014',
                                    cursor: 'pointer'
                                }
                            }, isSynced ? '已同步' : '未同步')
                        ]);
                    }
                }
            ];

            if (this.showYSColumns) {
                const insertIndex = baseColumns.findIndex(col => col.key === 'preSaleDeliveryRecordLogisticsCompanyName');
                return [
                    ...baseColumns.slice(0, insertIndex),
                    ...ysColumns,
                    ...baseColumns.slice(insertIndex)
                ];
            }

            return baseColumns;
        },
        checkStatusOrderIcon() {
            if (this.checkStatusOrder == 1) {
                return 'md-arrow-round-up';
            }
            else if (this.checkStatusOrder == 2) {
                return 'md-arrow-round-down';
            }
            else {
                return 'md-reorder';
            }
        },
        deliveryOrderIcon() {
            if (this.deliveryOrder == 1) {
                return 'md-arrow-round-up';
            }
            else if (this.deliveryOrder == 2) {
                return 'md-arrow-round-down';
            }
            else {
                return 'md-reorder';
            }
        },
        receiveOrderIcon() {
            if (this.receiveOrder == 1) {
                return 'md-arrow-round-up';
            }
            else if (this.receiveOrder == 2) {
                return 'md-arrow-round-down';
            }
            else {
                return 'md-reorder';
            }
        }
    },
    methods: {
        init() {
            this.getMainTableRecords();
            this.getRegionList();
            const compareTime = (targetTime) => {
                const v1 = new Date();
                const v2 = new Date(targetTime);
                const diffHours = Math.abs(v1 - v2) / (60 * 1000);
                if (diffHours >= 1440) {
                    return true;
                }
                else {
                    return false;
                }
            };
        },
        getPreSaleDeliveryRecordStatus(status) {
            const statusMap = {
                [-1]: '未提交',
                [0]: '未发货',
                [1]: '已发货',
                [2]: '关闭',
                [3]: '撤单'
            };
            return statusMap[status] || '';
        },
        renderYSTransferApply(h, row) {
            if (row.userCustomerManagerName === '总合计' || row.userCustomerManagerName === '本页合计') {
                return h('span', '');
            }
            const { ysTransferApplyId, transferApplyType, preSaleDeliveryRecordUuid, preSaleDeliveryRecordStatus } = row;
            const isSyncedId = ysTransferApplyId && ysTransferApplyId.toString().trim() !== '';

            if (!isSyncedId) {
                return this.renderYSUnsynced(h, preSaleDeliveryRecordUuid, transferApplyType, preSaleDeliveryRecordStatus);
            }
            return this.renderYSSynced(h, preSaleDeliveryRecordUuid, transferApplyType);
        },
        renderYSUnsynced(h, uuid, type, status) {
            const statusInfo = this.getYSStatusInfo(type);
            const isShipped = status === 1;

            if (!isShipped) {
                return h('Tooltip', {
                    props: { content: '仅已发货状态可同步', placement: 'top', transfer: true }
                }, [
                    h('span', {
                        style: { color: '#c5c8ce', cursor: 'not-allowed' }
                    }, '未同步'),
                    statusInfo.text ? h('span', {
                        style: { color: statusInfo.color, fontWeight: '500', marginLeft: '4px' }
                    }, statusInfo.text) : null
                ]);
            }

            return h('Tooltip', {
                props: { content: '点击同步', placement: 'top', transfer: true }
            }, [
                h('span', {
                    style: { color: '#ed4014', cursor: 'pointer', textDecoration: 'underline' },
                    on: { click: () => this.handleYSTransferApplySync(uuid) }
                }, '未同步'),
                statusInfo.text ? h('span', {
                    style: { color: statusInfo.color, fontWeight: '500', marginLeft: '4px' }
                }, statusInfo.text) : null
            ]);
        },
        renderYSSynced(h, uuid, type) {
            const status = this.getYSStatusInfo(type);
            const applyTypeText = this.getYSTransferApplyTypeText(type);
            const config = this.ysStatusConfig;

            const showWithdraw = type !== 0 && type !== config.TransferapplyDelType;

            return h('div', [
                h('Tooltip', {
                    props: {
                        content: applyTypeText ? `${applyTypeText} - ${status.text || '已同步'}` : (status.text || '已同步'),
                        placement: 'top',
                        transfer: true
                    }
                }, [
                    h('span', {
                        style: { color: status.color || '#19be6b', fontWeight: '500' }
                    }, status.text || '已同步')
                ]),
                showWithdraw ? h('Button', {
                    props: {
                        type: 'text',
                        size: 'small',
                        shape: 'circle'
                    },
                    style: {
                        color: '#2d8cf0',
                        marginLeft: '8px',
                        textDecoration: 'underline'
                    },
                    on: {
                        click: () => {
                            this.handleYSTransferApplyDel(uuid);
                        }
                    }
                }, '撤回') : null
            ]);
        },
        getYSStatusInfo(type) {
            const config = this.ysStatusConfig;
            const statusMap = {
                [config.StoreinUnauditType]: { text: '调入弃审', color: '#ff9900' },
                [config.StoreinDelType]: { text: '调入撤回', color: '#999999' },
                [config.StoreoutUnauditType]: { text: '调出弃审', color: '#ff9900' },
                [config.StoreoutDelType]: { text: '调出撤回', color: '#999999' },
                [config.TransferapplyUnauditType]: { text: '调拨弃审', color: '#ff9900' },
                [config.TransferapplyDelType]: { text: '调拨撤回', color: '#999999' }
            };
            return statusMap[type] || { text: '', color: '' };
        },
        getYSTransferApplyTypeText(type) {
            const config = this.ysStatusConfig;
            const typeMap = {
                [config.TransferApply]: '调拨单',
                [config.Storeout]: '调出单',
                [config.Storein]: '调入单'
            };
            return typeMap[type] || '';
        },
        closeOrder(recordUuid) {
            this.$Modal.confirm({
                title: "是否确认关闭该发货单？",
                content: "",
                onOk: async () => {
                    this.mainTable.tableLoading = true;
                    closePreSaleDeliveryByUuid({ preSaleDeliveryRecordUuid: recordUuid }).then(res => {
                        this.mainTable.tableLoading = false;
                        if (res.code === 0) {
                            this.getMainTableRecords();
                            this.$Message.success('成功关闭该发货单！');
                        }
                    });
                }
            });
        },
        sumbitOrder(recordUuid) {
            this.$Modal.confirm({
                title: "是否确认提交此发货单？",
                content: "提交之后的发货单就不能修改了",
                onOk: async () => {

                    this.mainTable.tableLoading = true;
                    SubmitPreSaleDelivery({ preSaleDeliveryRecordUuid: recordUuid }).then(res => {
                        this.mainTable.tableLoading = false;
                        if (res.code === 0) {
                            this.paySumbit = false;
                            this.getMainTableRecords();
                            this.$Message.success({
                                content: '发货单提交成功',
                                duration: 2
                            });
                        }
                        else if (res.code == 4) {
                            let amount = res.data.amout;
                            let userUuid = res.data.userUuid;

                            this.$refs.PayModal.showModal(userUuid, amount);
                            // this.paySumbit=true;
                            // this.$Message.error({
                            // 	content: res.message,
                            // });
                        }
                        else {
                            this.$Message.error({
                                content: res.message
                            });
                        }
                    });
                }
            });
        },
        deleteOrder(recordUuid) {
            this.$Modal.confirm({
                title: "是否确认删除此发货单？",
                content: "",
                onOk: async () => {
                    this.mainTable.tableLoading = true;
                    DeletePreSaleDelivery({ preSaleDeliveryRecordUuid: recordUuid }).then(res => {
                        this.mainTable.tableLoading = false;
                        if (res.code === 0) {
                            this.getMainTableRecords();
                            this.$Message.success({
                                content: '发货单删除成功',
                                duration: 2
                            });
                        }
                        else {
                            this.$Message.error({
                                content: res.message,
                                duration: 2
                            });

                        }
                    });
                }
            });

        },
        receivingChange(recordUuid) {
            this.$Modal.confirm({
                title: "是否确认客户已收货？",
                content: "",
                onOk: async () => {
                    this.mainTable.tableLoading = true;
                    updatePreSaleDeliveryByUuid({ preSaleDeliveryRecordUuid: recordUuid }).then(res => {
                        this.mainTable.tableLoading = false;
                        if (res.code === 0) {
                            this.getMainTableRecords();
                            this.$Message.success('确认客户已收货');
                        }
                    });
                }
            });
        },
        onDeliveryChange() {
            this.deliveryOrder = (this.deliveryOrder + 1) % 3;
            this.getMainTableRecords();
        },
        onCheckStatusOrderChange() {
            this.checkStatusOrder = (this.checkStatusOrder + 1) % 3;
            this.getMainTableRecords();
        },
        onReceiveOrderChange() {
            this.receiveOrder = (this.receiveOrder + 1) % 3;
            this.getMainTableRecords();
        },
        setOrderCondition() {
            this.mainTable.tableSearch.order.enable = false;
            this.mainTable.tableSearch.order.conditions = [];

            if (this.checkStatusOrder == 1) {
                this.mainTable.tableSearch.order.conditions.push({
                    name: "preSaleDeliveryRecordStatus",
                    type: "asc"
                });
                this.mainTable.tableSearch.order.enable = true;
            }
            else if (this.checkStatusOrder == 2) {
                this.mainTable.tableSearch.order.conditions.push({
                    name: "preSaleDeliveryRecordStatus",
                    type: "desc"
                });
                this.mainTable.tableSearch.order.enable = true;
            }

            if (this.deliveryOrder == 1) {
                this.mainTable.tableSearch.order.conditions.push({
                    name: "stationDeliveryType",
                    type: "asc"
                });
                this.mainTable.tableSearch.order.enable = true;
            }
            else if (this.deliveryOrder == 2) {
                this.mainTable.tableSearch.order.conditions.push({
                    name: "stationDeliveryType",
                    type: "desc"
                });
                this.mainTable.tableSearch.order.enable = true;
            }

            if (this.receiveOrder == 1) {
                this.mainTable.tableSearch.order.conditions.push({
                    name: "preSaleDeliveryRecordReceivingStatus",
                    type: "asc"
                });
                this.mainTable.tableSearch.order.enable = true;
            }
            else if (this.receiveOrder == 2) {
                this.mainTable.tableSearch.order.conditions.push({
                    name: "preSaleDeliveryRecordReceivingStatus",
                    type: "desc"
                });
                this.mainTable.tableSearch.order.enable = true;
            }

        },
        onUserTypeChage(e) {
            this.getMainTableRecords();
        },
        onExport() {
            this.mainTable.tableLoading = true;


            if (this.userType) {
                search.globalRemoveFilterConditionKey(this.mainTable.tableSearch, "memberType");
                this.mainTable.tableSearch.filters.enable = true;
                this.mainTable.tableSearch.filters.conditions.push({
                    name: 'memberType',
                    type: 'eq',
                    value: this.userType
                });
            }

            let tableSearch = JSON.parse(JSON.stringify(this.mainTable.tableSearch));
            tableSearch.excelExport.enable = true;
            this.setOrderCondition();
            getPreSaleDeliveryList({ ...tableSearch, needExport: 1 }).then(res => {
                if (res.code === 0) {
                    let url = DOWNLOAD_SERVER + res.data.exportFileName;
                    this.$downLoadFile(url);
                }
                this.mainTable.tableLoading = false;
            });
        },
        getMainTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }

            if (this.userType) {
                search.globalRemoveFilterConditionKey(this.mainTable.tableSearch, "memberType");
                this.mainTable.tableSearch.filters.enable = true;
                this.mainTable.tableSearch.filters.conditions.push({
                    name: 'memberType',
                    type: 'eq',
                    value: this.userType
                });
            }
            this.setOrderCondition();
            return getPreSaleDeliveryList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.tableData = res.data.records;
                    if (res.data.thisPagesumRecord) {
                        this.mainTable.tableData.push(res.data.thisPagesumRecord);
                    }
                    if (res.data.sumRecord) {
                        this.mainTable.tableData.push(res.data.sumRecord);
                    }
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }
                else {
                    this.$Message.error(res.message || '获取发货单列表失败');
                    console.error('获取发货单列表失败:', res);
                }
                this.mainTable.tableLoading = false;
            }).catch(err => {
                this.mainTable.tableLoading = false;
                this.$Message.error('获取发货单列表失败，请稍后重试');
                console.error('获取发货单列表失败:', err);
            });
        },
        onRefundGoodsClose() {
            this.getMainTableRecords();
        },
        revoke(recordUuid) {
            this.revokeModal.recordUuid = recordUuid;
            this.revokeModal.revokeRemarks = '';
            this.revokeModal.show = true;
        },
        revokeSave() {
            this.$refs.revokeModal.validate(valid => {
                if (!valid) {
                    this.$Message.error('表单验证失败!');
                    return;
                }
            });
            this.mainTable.tableLoading = true;
            canclePreSaleDeliveryByUuid({ preSaleDeliveryRecordUuid: this.revokeModal.recordUuid, cancelReason: this.revokeModal.revokeRemarks }).then(res => {
                this.mainTable.tableLoading = false;
                if (res.code === 0) {
                    this.getMainTableRecords();
                    this.revokeModal.show = false;
                    this.$Message.success('成功撤销该发货单！');
                }
            });
        },
        revokeCancal() {
            this.revokeModal.show = false;
            this.$refs.revokeModal.resetFields();
        },
        revokeDelivery(recordUuid) {
            this.$Modal.confirm({
                title: "是否确认撤销发货？",
                content: "",
                onOk: async () => {
                    this.mainTable.tableLoading = true;
                    cancelPreSaleDeliveryByUuidIn24({ preSaleDeliveryRecordUuid: recordUuid }).then(res => {
                        this.mainTable.tableLoading = false;
                        if (res.code === 0) {
                            this.getMainTableRecords();
                            this.$Message.success('成功撤销发货！');
                        }
                    });
                }
            });
        },
        returnDepositFee(recordUuid) {
            this.$Modal.confirm({
                title: "是否确认返还定金？",
                content: "",
                onOk: async () => {
                    this.mainTable.tableLoading = true;
                    depositBillOrderReturnDepositFee({ preSaleDeliveryRecordUuid: recordUuid }).then(res => {
                        this.mainTable.tableLoading = false;
                        if (res.code === 0) {
                            this.getMainTableRecords();
                            this.$Message.success('成功返还定金！');
                        }
                    });
                }
            });
        },
        getRegionList() {
            webGetAllRegion().then(res => {
                if (res.code === 0) {
                    this.allRegions = res.data.allRegions;
                    this.provinceOptions = this.allRegions.filter(r => r.regionType === 1).map(a => ({ key: a.regionName, value: a.regionUuid }));

                    let orderList = ['云南', '广东', '山东', '辽宁', '江苏', '福建', '上海', '河南', '新疆', '四川', '北京', '浙江', '湖北', '海南', '安徽', '河北', '黑龙江', '陕西', '天津', '贵州', '甘肃', '吉林', '湖南', '山西', '宁夏', '江西', '重庆', '广西', '西藏', '内蒙古', '全国', '香港'];

                    const getIndex = provin => {
                        let index = orderList.findIndex(element => element === provin.key);
                        index = index > -1 ? index : 999;
                        return index;
                    };
                    //排序
                    this.provinceOptions.sort((a, b) => getIndex(a) - getIndex(b));

                    let provinceItem = this.mainTable.searchForm.find(item => item.name === 'depositBillRecordProvince');
                    provinceItem.options = this.provinceOptions;
                }
            });
        },
        // 省份变更处理
        onProvinceChange(provinceUuid) {
            this.cityOptions = this.allRegions.filter(
                (r) => r.regionType === 2 && r.regionParentUuid === provinceUuid
            ).map(a => ({ key: a.regionName, value: a.regionUuid }));
            this.mainTable.searchForm.find(item => item.name === 'depositBillRecordCity').options = this.cityOptions;

            let distItem = this.mainTable.searchForm.find(item => item.name === 'depositBillRecordDist');
            distItem.options = [];
            distItem.value = [];
        },
        // 城市变更处理
        onCityChange(cityUuid) {
            this.distOptions = this.allRegions.filter(
                (r) => r.regionType === 3 && r.regionParentUuid === cityUuid
            ).map(a => ({ key: a.regionName, value: a.regionUuid }));
            this.mainTable.searchForm.find(item => item.name === 'depositBillRecordDist').options = this.distOptions;
        },
        applyInvoice(preSaleDeliveryRecordUuid, smallTotalOrderCost, totalPackageFee, preSaleDeliveryRecordTotalLogisticsPrice, preSaleDeliveryRecordTotalCost) {
            if (!preSaleDeliveryRecordUuid) {
                this.$Message.error('缺少发货单UUID，无法申请发票');
                return;
            }

            try {
                // 直接调用子组件的showModal方法，让子组件自己控制弹窗显示
                this.$refs.invoiceModal.showModal(preSaleDeliveryRecordUuid, smallTotalOrderCost, totalPackageFee, preSaleDeliveryRecordTotalLogisticsPrice, preSaleDeliveryRecordTotalCost);
            }
            catch (error) {
                console.error('调用发票申请弹窗失败:', error);
                this.$Message.error('打开发票申请弹窗失败，请稍后重试');
            }
        },
        handleInvoiceSubmit(invoiceData) {
            // 处理发票提交
            console.log('接收到发票提交数据:', invoiceData);

            // 验证提交数据的完整性
            if (!invoiceData || !invoiceData.deliveryUuid) {
                this.$Message.error('发票申请数据不完整，请重试');
                return;
            }

            // 显示加载状态
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                size: 18
                            }
                        }),
                        h('div', '正在提交发票申请...')
                    ]);
                }
            });

            // 这里应该调用真实的API提交发票信息
            import('@/api/modules/finance-management/invoice').then(({ submitInvoice }) => {
                submitInvoice(invoiceData).then(res => {
                    this.$Spin.hide();
                    if (res.code === 0) {
                        this.$Message.success('发票申请成功！');
                        this.getMainTableRecords(); // 刷新列表
                        this.invoiceModalVisible = false; // 关闭弹窗
                    }
                    else {
                        this.$Message.error(res.message || '发票申请失败');
                    }
                }).catch(err => {
                    this.$Spin.hide();
                    console.error('发票申请失败:', err);
                    this.$Message.error('发票申请失败，请稍后重试');
                });
            }).catch(() => {
                // 如果API不存在，临时模拟成功处理
                setTimeout(() => {
                    this.$Spin.hide();
                    this.$Message.success('发票申请成功！（演示模式）');
                    console.log('模拟发票申请成功，提交数据:', invoiceData);
                    this.getMainTableRecords(); // 刷新列表
                    this.invoiceModalVisible = false; // 关闭弹窗
                }, 1500);
            });
        },
        handleInvoiceCancel() {
            // 处理发票取消
            console.log('用户取消发票申请');
            this.$Message.info('已取消发票申请');
            this.invoiceModalVisible = false; // 确保弹窗关闭
        },
        handleInvoiceSubmitted() {
            console.log('开票提交事件: 成功');
            this.mainTable.tableLoading = true;
            this.getMainTableRecords();
        },
        handleInvoiceSubmitError() {
            console.error('开票提交事件: 失败');
            this.$Message.error('开票提交失败，请稍后重试');
        },
        handleYSTransferApplySync(recordUuid) {
            const record = this.mainTable.tableData.find(item => item.preSaleDeliveryRecordUuid === recordUuid);

            if (!record) {
                this.$Message.error('未找到该发货单记录');
                return;
            }

            if (record.preSaleDeliveryRecordStatus !== 1) {
                this.$Message.error('仅已发货状态可同步用友调拨单');
                return;
            }

            this.$Modal.confirm({
                title: '同步用友调拨单',
                content: '确认同步该发货单的用友调拨单？',
                onOk: () => {
                    this.mainTable.tableLoading = true;
                    ysTransferApplySync({
                        preSaleDeliveryRecordUuid: recordUuid
                    }).then(res => {
                        if (res.code === 0) {
                            this.$Message.success('用友调拨单同步成功！');
                            setTimeout(() => {
                                this.getMainTableRecords();
                            }, 500);
                        }
                        else {
                            this.mainTable.tableLoading = false;
                            this.$Message.error(res.message || '用友调拨单同步失败');
                        }
                    }).catch(err => {
                        this.mainTable.tableLoading = false;
                        console.error('用友调拨单同步失败:', err);
                        this.$Message.error('用友调拨单同步失败，请稍后重试');
                    });
                }
            });
        },
        handleYSTransferApplyDel(recordUuid) {
            this.$Modal.confirm({
                title: '撤回用友调拨单',
                content: '确认撤回该发货单的用友调拨单？',
                onOk: () => {
                    this.mainTable.tableLoading = true;
                    ysTransferApplyDel({
                        preSaleDeliveryRecordUuid: recordUuid
                    }).then(res => {
                        this.mainTable.tableLoading = false;
                        if (res.code === 0) {
                            this.$Message.success('用友调拨单撤回成功！');
                            this.getMainTableRecords();
                        }
                        else {
                            this.$Message.error(res.message || '用友调拨单撤回失败');
                        }
                    }).catch(err => {
                        this.mainTable.tableLoading = false;
                        console.error('用友调拨单撤回失败:', err);
                        this.$Message.error('用友调拨单撤回失败，请稍后重试');
                    });
                }
            });
        },

        async viewInvoice(row) {
            try {
                if (!row.invoiceSerialNum) {
                    this.$Message.warning("暂无发票信息");
                    return;
                }

                // 2. Call getInvoiceInfo
                const infoRes = await getInvoiceInfo({
                    serialNo: row.invoiceSerialNum.split(',')[0]
                });

                if (infoRes.code === 0) {
                    window.open(infoRes.data.pdfurl, "_blank");
                }
                else {
                    this.$Message.error(infoRes.message);
                }

            }
            catch (error) {
                console.error('viewInvoice error:', error);
                this.$Message.error('系统异常，请稍后重试');
            }
        },
        handleInvoiceInfoResult(result) {
            const firstResult = result && result.length > 0 ? result[0] : null;
            if (!firstResult) {
                this.$Message.error('无法获取发票详情');
                return;
            }

            if (String(firstResult.status) === '2') {
                const targetUrl = firstResult.pdfUrl || (firstResult.pictureUrl ? 'https://' + firstResult.pictureUrl : null);
                if (targetUrl) {
                    window.open(targetUrl, "_blank");
                }
                else {
                    this.$Message.error('无法获取发票链接');
                }
            }
            else {
                this.$Message.warning((firstResult.statusMsg || '发票开具中') + ' - 请稍后再查看');
            }
        }
    }
};
</script>

<style scoped></style>
